import { withChildren } from '@builder.io/react';
import { createBuilderModule } from '../../../builder';
import { withTracking } from '../../../observability';
import { HeroCentered } from './HeroCentered';

export default createBuilderModule(
  withChildren(withTracking(HeroCentered, { sectionName: 'HeroCentered' })),
  {
    name: 'HeroCentered',
    image: 'https://cdn.zappy.app/2f2b5c4f4b8e4b6e8b2a6b7a3b7a0d3a.png',
    inputs: [
      {
        name: 'heading',
        type: 'string',
        required: true,
      },
      {
        name: 'description',
        type: 'richText',
      },
      {
        name: 'buttons',
        type: 'list',
        subFields: [
          {
            name: 'variant',
            type: 'string',
            enum: ['primary', 'primary-alt', 'secondary'],
            defaultValue: 'primary',
          },
          {
            name: 'text',
            type: 'string',
          },
          {
            name: 'url',
            friendlyName: 'URL',
            type: 'string',
          },
          {
            name: 'showGoogleIcon',
            friendlyName: 'Show Google icon',
            type: 'boolean',
          },
        ],
      },
      {
        name: 'checklistItems',
        type: 'list',
        subFields: [
          {
            name: 'text',
            type: 'richText',
          },
        ],
      },
      {
        name: 'backgroundColor',
        type: 'string',
        enum: ['neutral100', 'lavender', 'peach', 'bolt', 'sky', 'cream'],
        defaultValue: 'neutral100',
      },
      {
        name: 'size',
        type: 'string',
        enum: ['regular', 'large'],
        defaultValue: 'regular',
      },
    ],
  },
);
